import classNames from "classnames";
import NavbarClassic from "@components/layout/Navbar/NavbarClassic";
import WarningRibbon from "@components/layout/WarningRibbon";
import CartModal from "@components/views/Cart/CartModal";
import PromoBannerContainer from "@components/layout/PromoBannerContainer";

const Header = ({ noStickyHeader, context }) => (
  <>
    <WarningRibbon />
    <PromoBannerContainer />
    <header className={classNames(!noStickyHeader && "sticky-top")}>
      <NavbarClassic context={context} />
      <CartModal />
    </header>
  </>
);

export default Header;
